/* JoyBundle — product page behaviour.
 *
 * 承载图廊切换、套餐选择、FAQ 折叠三块行为，替代原先的三个内联函数：
 *   图廊切换  原实现读取隐式全局 `event`（非标准，strict mode 下会失败），
 *             且图片路径硬编码在 onclick 里。
 *   份数选择  原实现靠抓取 .pack-count / .pack-price 的 textContent 拼按钮文案，
 *             完全没有联动购物车状态。
 *   FAQ 折叠  逻辑本身没问题，只是写成了内联。
 *
 * Every listener here is delegated on `document`, so nothing needs rebinding when
 * the theme editor re-renders a section.
 */
(function () {
  'use strict';

  function closest(target, sel) {
    return target && target.closest ? target.closest(sel) : null;
  }

  /* ---------- Gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = closest(e.target, '.gallery-thumb[data-image]');
    if (!thumb) return;

    var gallery = thumb.closest('.product-gallery');
    if (!gallery) return;

    var main = gallery.querySelector('.gallery-main img');
    if (main) {
      main.src = thumb.getAttribute('data-image');
      var alt = thumb.getAttribute('data-alt');
      if (alt) main.alt = alt;
    }
    Array.prototype.forEach.call(gallery.querySelectorAll('.gallery-thumb'), function (t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  });

  /* ---------- Pack size ----------
   * 这三张卡片选的是**份数**，不是变体 —— 商品只有一个 Default Title 变体。
   * 点击写的是表单里的 hidden quantity，和 name="id" 一样是真的 cart payload，
   * 不是抓 .pack-count 的 textContent 拼文案。
   *
   * 这里不再改 URL 的 ?variant= —— 单变体商品上那个参数没有意义。
   */
  document.addEventListener('click', function (e) {
    var option = closest(e.target, '.pack-option[data-quantity]');
    if (!option || option.hasAttribute('data-unavailable')) return;

    var group = option.closest('.pack-options');
    var form = document.getElementById('product-form');
    if (!group || !form) return;

    Array.prototype.forEach.call(group.querySelectorAll('.pack-option'), function (o) {
      o.classList.remove('selected');
      o.setAttribute('aria-checked', 'false');
      o.setAttribute('tabindex', '-1');
    });
    option.classList.add('selected');
    option.setAttribute('aria-checked', 'true');
    option.setAttribute('tabindex', '0');

    var input = form.querySelector('input[name="quantity"]');
    if (input) input.value = option.getAttribute('data-quantity');   // the actual cart payload

    var addBtn = form.querySelector('.add-to-cart');
    if (addBtn) addBtn.textContent = option.getAttribute('data-atc-label');
  });

  /* ---------- FAQ ----------
   * 面板靠 aria-controls 指向的 id 定位，不是 nextElementSibling —— 问题按钮包在 <h3> 里
   * （APG accordion，让读屏能按标题在问题间跳转），button.nextElementSibling 是 null。
   * 所以 aria-controls 在这里是实际接线，不是装饰：动了 id 配对就会静默半失效 ——
   * class 和 aria-expanded 照翻，面板永远不开。
   */
  document.addEventListener('click', function (e) {
    var q = closest(e.target, '.faq-q');
    if (!q) return;
    var a = document.getElementById(q.getAttribute('aria-controls'));
    var open = q.classList.toggle('open');
    if (a) a.classList.toggle('open', open);
    q.setAttribute('aria-expanded', String(open));
  });

  /* ---------- 给基于 div 的控件补齐键盘操作 ----------
   * .faq-q 不在这个列表里 —— 它已经是真 <button>，Enter/Space 原生就触发 click。
   * 加回来会变成一条多余且脆弱的双路径：preventDefault 吞掉原生行为，再手动 click() 补一次。
   * 剩下这两个仍是 div 控件（role=button / role=radio），shim 还得为它们存在。
   */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = closest(e.target, '.gallery-thumb[data-image], .pack-option[data-quantity]');
    if (!el) return;
    e.preventDefault();
    el.click();
  });
})();
